import React, { Component } from 'react';
import './step.css';



function Step3 (props){
  var stuffToSell=props.selling.map((sell, index) =>
  <div className="selling" key={index}>
    <span className="item">{sell[0]}:</span>
    <span className="item-price">${sell[1]}</span>
    <button className="remove-button" id={index} onClick={props.removeSelling}>Remove this item from your offer</button>
  </div>
)


  return(
    <div>
      <div className="offer-holder">
        {stuffToSell}
      </div>
      <div>
      <div className="offer-holder-add">
        <input type="text" onChange={props.addSell} id="offer-what" placeholder="What are you selling?"/>
        <input type="num" onChange={props.addSellPrice} id="offer-price" placeholder="How much is it?"/>
        <button onClick={props.captureOffer} className="add-button">Offer this item for sale.</button>
      </div>
      <textarea onChange={props.addTerms} rows="6" cols="70" className="offer-terms" placeholder="Add offer terms"/>
      <textarea onChange={props.howToUse} rows="6" cols="70" className="offer-how" placeholder="Usage Instructions" />
      <div id="widget-container"></div><button className="widget-button" onClick={props.createWidget}>Get Widget Code for your website</button>
      <textarea rows="6" cols="70" id="widget-code"/>
        <input type="file" className="add-logo" onChange={props.addLogo} name="pic" accept="image/*"/>

        {props.logo[0]}
        <div className="profile-step"><button id="step3-button" className="step-button" onClick={props.submitOffer} type="submit"><a href="/profile">View Profile</a></button></div>
        <h2 className="stepNumber">Step 3 of 3</h2>
      </div>
    </div>)
}






export default Step3;



// WEBPACK FOOTER //
// ./src/step3.js